let activeTrackingSiteUrl = "";

export function setTrackingSiteUrl(siteUrl) {
  activeTrackingSiteUrl = String(siteUrl || "").trim();
}

export function getTrackingSiteUrl() {
  return activeTrackingSiteUrl;
}
